import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { thunk } from 'redux-thunk';
//import { reduxJsonFormReducer } from '@deecide/redux-json-form/lib/redux_json_form_reducer/reducer';
import { reduxJsonFormReducer } from 'store/json_form_reducer';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable */

const fieldsToExclude = ['password', 'confirm_password', 'user.password', 'user.confirm_password'];

export const actionSanitizer = (action) => {
  if (action.meta && fieldsToExclude.includes(action.meta.field)) {
    return null;
  }
  return action;
};

const allReducers = combineReducers({
  form: reduxJsonFormReducer,
});

export const store = createStore(allReducers, composeEnhancers(applyMiddleware(thunk)));

const WithStore = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};

WithStore.propTypes = {
  children: PropTypes.object.isRequired,
};

export default WithStore;
